export type TableExportFormat = "csv" | "xlsx" | "json";
export type ExportFormat = TableExportFormat | "png";

export const exportFormats: TableExportFormat[] = [
  "csv",
  "xlsx",
  "json",
] as const;
export const exportFormatPng: ExportFormat = "png" as const;
